/**
* Chinese Traditional
*
*/
const locale = {
	schedule: {
		"Lesson Color": "課程顏色",
		"Select": "選擇",
		"Same date will only create single lesson": '日期相同時創建單次課節',
		'Class': '班級',
		'Select Class To Add Lesson': '選擇班級進行排課',
		'Select Class': '選擇班級',
		calendar: {
			"Attended": "已簽到",
			"Lesson": "課節",
		},
		'Attended lesson cannot be moved': '已簽到的課節不能被移動！',
		'(Lesson {lesson_number})': '(課節 {lesson_number})',
		'Time: {time}': '上課： {time}',
		'Classroom: {classroom}': '教室： {classroom}',
		'Student: {number}': '學員： {number} 人',
		"Attended": "已簽到",
		'Unattended': '未簽到',
		'All Teachers': '所有老師',
		'All Classes': '所有班級',
		'All Classrooms': '所有教室',
		'Add Lesson': '添加課程'
	},
	header: {
		"Change Language": "切換語言",
		"Premium Version": "升級高級版",
		"Privacy": '隱私政策',
		"Settings": '查看資料',
		"Switch School": '切換學校',
		"Personal Settings": '個人設置',
		"Sign Out": "登出",
		"Payment Information": '支付信息',
		"Please Enter Payment Information In Order To Upgrade To Permium Version ($79 USD per month per school), Invoice Will Be Sent Eletronically Via Email Every Month": '請填寫您的支付信息以確保您能正常使用高級版 (每月每學校$79 USD), 我们會通過郵件發送每個月的帳單',
		sidemenu: {
			"My channel": "我的頻道",
			"Class Schedule": "課表",
			"Student": "學員",
			"Class": "班級",
			"Private Class": "私課",
			"Teacher": "老師",
			"Classroom": "教室",
			"Announcement": "公告",
			"Statement Detail": "收支明细",
			"Monthly Summary": "月度匯總",
			"School Management": "學校管理",
			"School Administration": "教務權限",
			"School Information": "學校信息",
			"Sales Management": "銷售管理",
		},
		panelmenu: {
			"Teaching Management": "教學管理",
			"Financial Management": '財務管理',
			"School Management": '學校管理',
			"Sales Management": '營銷管理',
			'This feature is under development': '此功能正在開發中'
		}
	},
	checkoutform: {
		"Your purchase is successful!": "購買成功！",
		"Email Address": "郵件地址",
		"Credit or Debit Card": "信用卡或儲蓄卡資料",
		"Submit Payment": "購買",
		"Please Enter Email Address!": "必須填寫郵件地址！"
	},
	appwrapper: {
		"All field must be filled!": "必須填寫！",
		"Please enter your phone number": "請輸入您的手機號",
		"Next ": '下一步 ',
		"Verify your phone number": "驗證您的手機號",
		"Verification code not received in 60 seconds ": "60秒後還未收到 請 ",
		"Resend ": '重新發送 ',
		"code": "驗證碼",
		"Verification Code": "輸入四位驗證碼",
		"Password": '密碼',
		"Register": "註冊",
		"Verify your phone number": "驗證您的手機號",
		"Register successful": "註冊成功",
		'Create school': '開始創建學校',
		'School Information': '創建新學校必填內容',
		"School Name": '學校名字',
		"School Description": '學校描述',
		'School Type': '學校類型',
		'After School Class': '課後輔導班',
		'Pre School': '學前班',
		"Tutor": '家教',
		"The verification code is sent to: {phone}": '您的手機 {phone} 會收到驗證簡訊',
		'Login phone number {phone}': '登入手機號 {phone}',
		'Public/Private School': '公校/私校',
		'Student Enrollment Age Limit': '招收學員年齡下限',
		'Years Old': '歲',
		'Country': '選擇國家',
		'Province/States': '選擇地區',
		'City': '輸入城市',
		'Time Zone (Cannot Change After Saved)': '時區 (一旦保存不可更改)',
		'Currency (Cannot Change After Saved)': '貨幣 (一旦保存不可更改)',
		'Complete': '完成',
		'Sign In': '登入',
		'Forgot Password': '忘記密碼',
		'Register New Account': '註冊帳戶'
	},
	changeschool: {
		"You are over the school limit, please upgrade to Premium Version": "您目前的校區上限為1個校區, 添加更多校區請升級為高級版",
		"Create a new school ($79 USD per month per school), invoice will be sent eletronically via Email every month ": '創建新的1所學校 (每個月每學校 $79 USD), 我们會通過郵件發送每個月的帳單',
		"Cancel": '取消',
		"Save": '確認',
		' Create New School': ' 創建新學校',
		'Principle': '校長',
		'Teacher': '老師',
		'Decline': '拒絕',
		'Accept': '接受',
		'Delete School: {school_name}?': '確認刪除學校: {school_name} ?',
		" Delete": ' 刪除',
		"Exit School: {school_name}?": "確認退出學校: {school_name} ?",
		" Exit": ' 退出',
		'My School': '我的學校',
		"Delete School": '删除學校',
		" Back to My School": ' 返回我的學校'
	},
	administration:{
		"Permission Management": "權限管理",
		"Read Student": "讀取學員",
		'Edit Student': '更改學員',
		'Read Class': '讀取班級',
		'Edit Class': '更改班級',
		'Read Teacher': '讀取老師',
		'Edit Teacher': '更改老師',
		"Read Classroom": '讀取教室',
		'Edit Classroom': '更改教室',
		'Read Finance': '讀取財務',
		"Edit Finance": '更改財務',
		'Read Attendance': '讀取簽到',
		"Edit Attendance": '更改簽到',
		"Read Lesson": '讀取課節',
		"Edit Lesson": '更改課節',
		'Read Announcement': '讀取公告',
		'Edit Announcement': '更改公告',
		'Read Permission': '讀取權限',
		'Edit Permission': '更改權限',
		'Cannot delete this group': '無法刪除角色組',
		'Delete Group {group_name} ?': '確認刪除角色組：{group_name} ?',
		'Create New Group': '創新新角色組',
		" Edit": ' 編輯',
		'Group Members': '角色組成員'
	},
	createadministration: {
		'New Group Name': '新角色組名稱',
		"Add": '添加',
		"Added": '已添加',
		'Select Teacher': '選擇老師',
		"Add Member": '添加成員',
		"Please enter a group name": '請填寫角色組名稱',
		'Please select permissions': '請選擇權限',
		"Please select members": '請選擇成員',
		' Back': ' 返回'
	},
	announcement: {
		"All Classes and Studnets" : '全體師生',
		"Delete Announcement: {title}": '確認刪除公告：{title} ？',
		"Announcer: ": "發布者：",
		'Date/Time: ': '發布時間：',
		'Send To: ': '發布送至： ',
		'Please enter announcement title': '請輸入通告標題搜索',
		'All': '全部',
		'New Announcement': '新建公告',
		'Edit Announcement': '編輯公告',
		'Please Enter Announcement Title': '請填入公告標題後才可以發布',
		'For: ': '公告對象: ',
		'Title: ': '公告標題： '
	},
	attendance:{
		" Attendance Record": " 簽到紀錄"
	},
	class: {
		'New Class: {new_cname} Has Been Created!': '新班級 {new_cname} 已創建！',
		'Class: {cname} Has Been Updated!': '班級 {cname} 已更新！',
		'Class: {cname} Has Been Archived': '班級 {cname} 已歸檔',
		'Class: {cname} Has Been Unarchived': '班級 {cname} 已恢復歸檔',
		'Class: {cname} Error': '班級 {cname} 操作失敗',
		'Class Status Update Failure: Network Connection Issue!': '班級狀態更新失敗：Network connection issue!',
		'Class: {cname} Archived?': '確認對 {cname} 班級進行歸檔？',
		'Lesson Scheduled': '已排課',
		'Lesson Started': '已開始上課',
		"Add Lesson": '增加課節',
		"Archived": '歸檔',
		"Unarchived": '恢復歸檔',
		"View": '查看',
		"Edit": '編輯',
		'Search Class': '請輸入關鍵詞搜索',
		'Current Class': '當期班級',
		'Archived Class': '歸檔班級',
		'Add Class': '新增班級',
		'Class Name': '班級名稱',
		'Date': '日期',
		'Lesson Amount': '課節數',
		'Teacher': '老師',
		'Price': "總價",
		'Students': '學員',
		'Status': '狀態',
		'Settings': '操作'
	},
	createnewclass:{
		'Create Class Failure': '班級創建失敗',
		'Class Teacher Update Failure': '班级老師更新失敗',
		'Class Student Update Failure': '班级學員更新失敗',
		'All Fields with * Must Be Filled': '带*號的字段必須填寫',
		'Remaining {i} Day' : '剩餘 {i} 天提醒',
		'Reminder': '提醒時間',
		'Remaining {i} Lesson': '剩餘{i}節課提醒',
		'Create New Class': '新增班級',
		'Enter Class Name': '輸入班級名稱',
		'Charged Reminder Options': '收費提醒方式',
		'Remind at End Date': '到期日提醒',
		'Remind at Last Lesson': '課次消耗完提醒',
		'Student Number': '招生人數',
		'': '人',
		'Lesson Completion Rules': '課消規則',
		'Attending count as completion': '按簽到算課消',
		'Absence count as completion': '請假算課消',
		'Truancy count as completion': '缺課算課消'
	},
	editclass: {
		'Class Update Failure': '班級更新失敗',
		'Edit Class': '編輯班級'
	},
	classdetail:{
		'Attended': '出勤',
		'Class: {cname} Has Been Updated!': '班級 {cname} 已更新！',
		'Lesson Teacher Updated': '課節老師已更新',
		'Lesson Teacher Update Failure': '課節老師更新失敗',
		'New Lesson: {new_name} Saved': '新課節 {new_name} 已保存',
		'Lesson Name Update Failure': '課節名稱更新失敗',
		'Lesson Deleted': '課節已刪除',
		'Lesson Delete Failure': '刪除課節失敗',
		'Lesson: {lesson_name} Added': '課節: {lesson_name} 已添加',
		'Add Lesson Failure': '添加課節失敗',
		'Student Has Exited Class': '學員已退班',
		'Student Exit Class Failure': '學員退班失敗',
		'Student: {studnet_name} refunded {amount_of_money} {currency} successful!': '學員: {student_name} 退款 {amount_of_money} {currency} 成功！',
		'Student: {studnet_name} added credit {amount_of_money} {currency} successful!': '學員 {student_name} 充值 {amount_of_money} {currency} 成功！',
		'Student: {studnet_name} charged {amount_of_money} {currency} successful!': '學員 {student_name} 收費 {amount_of_money} {currency} 成功！',
		"Delete {name}'s Lesson?": '確認刪除 {name} 的課節?',
		'Class Price': '課程總價',
		'Payment Reminder': '收費提醒',
		'Past Lesson Counts': '已上課節',
		'Enrollment Status': '招生情況',
		'Checked In': '已簽到',
		'Check In': '簽到',
		'Remaining': '餘',
		'Overdue ': '欠費 ',
		'Exited Class': '已退班',
		'Student Detail': '查看學員資料',
		'Remarks': '備註',
		'Exit Class': '退班',
		'Exit Student: {name} From Class?': '確認對學員 {name} 進行退班?',
		'Refund and Exit Class': '退款並退班',
		'Add Student': '添加學員',
		'Search Students': '搜索學員名稱...',
		'{age} Years Old': '{age} 歲',
		'Attendance': '出勤簽到',
		'Lesson Completion Rule: ': '課消規則：',
		'Lesson Time: ': '上課時間：',
		'{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}': '{lsnStartDate1} 年 {lsnStartDate2} 月 {lsnStartDate3} 日 {lsnStartTime} - {lsnEndTime}',
		'None':'無',
		'Leave of Absence': '請假',
		'Late': '遲到',
		'Absence': '曠課',
		'Total of {total_amount} person {total_amount2} Attended': '共 {total_amount} 人 出勤 {total_amount2} 人',
		'Lesson': '課節',
		'Insufficient Account Balance, Please Top Up and Try Again': '當前您的錢包餘額不足，請充值後再使用',
		'Insufficient Balance. Please Top Up or Try Other Payment Options': '當使用錢包餘額時，收款金額不能大於錢包餘額！為了正常交易，您可以先充值在使用錢包或使用其他交易方式',
		'Exit Class Until': '退課期至',
		'Exit Class Number': '退課次',
		'': '次',
		'Account Balance: ': '錢包餘額: ',
		'Refund': '退款',
		'Refund Tuition': '直接退學費',
		'Refund Date': '退款日期',
		'Class': '班級',
		'Refund Options': '退款方式',
		'Cash': '現金',
		'Credit Card': '信用卡',
		'Cheque': '支票',
		'Bank Transfer': '轉帳',
		'Account Balance': '校內錢包',
		'Email': '郵箱',
		'Paper Receipt Number': '紙質收據號',
		'Send Recipt To Parents': '電子收據會通過郵件發送給家長',
		'Exit Student: {sname} From Class?': '確認對學員： {sname} 退班?',
		'Refund Date Cannot Be Empty': '退款日期不能為空',
		'Proceed To Refund transaction and Exit Class For Student: {sname} ?': '確認對學員 {sname} 進行退款和退班?',
		'Same date will only create single lesson': '日期相同時創建單次課節',
		'Start Date Must Be Earlier Than End Date': '開始日期必須早於或等於结束日期',
		'End Date Must Be Later Than Start Date': '结束日期必須晚於或等於開始日期',
		'End Time Must Be Later Than Start Time': '结束時間必須晚於開始時間',
		'Please Select Lesson Date and Time': '請選擇課節日期和時間',
		'End Date/Time Must Be Later Than Start Date/Time': '结束日期或時間必須晚於開始日期或時間',
		'Please Select Days': '請選擇周中日期',
		'Please Select Dates': '請選擇月中日期',
		'Please Select Lesson Date': '請選擇課節日期',
		'Select Student': '選擇學員',
		'Select Classroom': '選擇教室',
		'Search Classroom':'搜索教室',
		'Every': '每',
		'(Can Select Multiple)': '(可多選)',
		'Frequency': '頻率',
		'Start Date': '開始日期',
		'End Date': '结束日期',
		'Start Time (HH:MM)': '上課時間 (HH:MM)',
		'End Time (HH:MM)': '下課時間 (HH:MM)',
		'Batch Scheduling': '批量排課',
		'Lesson Has {student} Students': '班級學員 {student} 人',
		'Select': '選擇',
		'Classroom': '教室',
		'Conflict': '衝突',
		'Lesson Date': '上課日期',
		'Delete Lesson': '刪除這一課節',
		'ID': '序號',
		'Lesson Time': '上課時間',
		'Student Counts': '學員人數',
		'Class Student': '班級學員',
		'Lesson Count': '排課課次',
		'Lesson Status': '上課進度',
		'Checked In': '已簽到',
		'Please Select': '請選擇...',
		"When 'Account Balance' reaches 0, student: {name} will automatically exit class": '輸入‘退款金額’為零時，執行‘確定’後將學員 {name} 直接退出班級',
		'Please Select Class and Enter Refund Amount': '請您首先選擇班級，並填入退款金額'
	},
	classone:{
		'New class: {cname} Has Been Created': '新班級： {cname} 已創建',
		'Class: {cname} Has Been Updated': '班級： {cname} 已更新',
		'Class: {cname} Archived': '班級： {cname} 已歸檔',
		'Class: {cname} Unarchived': '班級： {cname} 已恢復歸檔',
		'Class: {cname} Failure': '班級： {cname} 操作失敗',
		'Class Status Update Failure': '班級狀態更新失敗',
		"Archived {studentName}'s {cName} ?" : "確認對學員 {studentName} 的 {cName} 進行歸檔？",
		'Scheduled': '已排課',
		'Class Started': '已開始上課',
		'Search Students': '請輸入學員名稱搜索',
		'Current Private Class': '當期私課',
		'Archived Private Class': '歸檔私課',
		'Add Private Class': '新增私課',
		'Student Name': '學員名稱',
		'Private Class Name': '私課名稱',
		'Enter Private Class Name': '輸入私課名稱'
	},
	schoolInformation: {
		"School Information": "學校基本信息",
		"Complete all information that helps your audience understand better on the Yellow Pages": "填寫完善的信息，將有助於您在黃頁上更清晰的展現您的學校",
		form: {
			"School Name": "學校中文名稱",
			"School Logo": "學校logo",
			"School Home Page": "學校官網主頁",
			"Time Zone": "時區",
			"Currency": "貨幣總類",
			"Phone": "學校聯繫電話",
			"Email": "學校聯繫Email",
			"School Type": "學校類型",
			"Category": "課程種類",
			"Student Age": "招收學員年齡",
		}
	},
	createone: {
		'Create Class Failure': '班級創建失敗',
		'Class Teacher Update Failure': '班級老師更新失敗',
		'Class Student Update Failure': '班級學員更新失敗',
		'Private Class': '私課',
		'Edit Student': '編輯學員',
		'Add New Private Class': '新增私課',
		'Edit Teacher': '編輯老師'
	},
	editone: {
		'Edit Private Class': '編輯私課',
		'Student Name': '學員姓名'
	},
	classroom: {
		'Classroom: {classroom} Has Been Created': '教室： {classroom} 創建',
		'Classroom: {classroom} Has Been Updated': '教室： {classroom} 已更新',
		'Create Classrom: {classroom} Successful': '新建教室： {classroom} 成功',
		"Classroom: {classroom}'s Info Has Been Saved'": '修改教室： {classroom} 的信息已保存',
		'Classroom: {classroom} Deleted': '刪除教室： {classroom} 完成',
		'Delete Classroom: {name} ?': '確認刪除： {name} 教室？',
		'Delete': '刪除',
		'Classroom ({amount})': '教室 ({amount})',
		'Create Classroom': '新增教室',
		'Classroom Name': '教室名稱',
		'Enter Classroom Name': '輸入教室名',
		'Edit Classroom': '編輯教室',
		'Amount': '退款金額'
	},
	teacher: {
		'Teacher: {tname} Has Been Created': '老師: {tname} 已創建',
		'Create Teacher Failure': '添加老師失敗',
		'Please exit from all current classes before archiving the teacher': '請您先退出當期班級，才可在學校中歸檔',
		"Teacher: {tname}'s Info Has Been Saved": '老師： {tname} 的信息已保存',
		"Teacher: {tname}'s Unarchived Failure": '老師： {tname} 恢復歸檔失敗',
		'Send Invitation To Teacher: {tname}?': '發送邀請給老師: {tname}?',
		'Created': '已創建',
		'Invited': '已邀請',
		'Confirm': '已確認',
		'Declined': '已拒絕',
		'Male': '男',
		'Female': '女',
		'Options': '更多操作',
		'Attendance': '簽到紀錄',
		'Upgrade to Premium': '升級高級版',
		'You are over the teacher limit, please upgrade to premium version': '您目前的老師上限為20個老師, 添加更多老師請升級為高級版',
		'Current Teachers': '當期老師',
		'Archived Teachers': '歸檔老師',
		'Add Teacher': '新增老師',
		'Teacher Name': '老師姓名',
		'Gender': '性別',
		'Mobile Phone Number': '手機號',
		'Lesson Taught Counts': '已教課次數',
		'Lesson Taught Hours': '已教課時',
		'Please enter a valid phone number': '請輸入正確的手機號碼',
		'Create New Teacher': '新增老師',
		"Enter Teacher's Name": '輸入老師姓名',
		'Save and Invite': '保存並邀請',
		'Edit Teacher': '編輯老師',
		'Date': '退款日期',
		'Amount': '收款金額',
		"Enter a phone number to invite teacher to download mobile App and the teacher could change attendance for themsevles and their students, as well as receiving announcement and schedule. You could change teccher's permission inside the permissions settings": '填寫手機號可以邀請老師下載手機端APP, 老師可以用APP給自己和學生簽到, 接收通知和課表, 您可以在權限設置裡安排老師的權限',
		'Phone number already existed': '此手機號已存在'

	},
	finance: {
		'Add Credit': '校內錢包',
		'Showing {amount} records Total of {amount2} records': '顯示 {amount} 條紀錄 全部 {amount2} 條紀錄',
		'{transaction_date} - {transaction_date2} - {transaction_date3}': '{transaction_date} 年 {transaction_date2} 月 {transaction_date3} 日',
		'Charge': '收費',
		'Refund': '退費',
		'Please enter remarks content': '請輸入備註內容',
		'Send To': '發送至',
		'Send': '發送',
		'Transaction Summary': '交易紀錄',
		'Student: ': '學員： ',
		'E-Reciept Number: ': '電子收據號： ',
		'All': '所有',
		'Class: ': '班級： ',
		'Date: ': '日期： ',
		'E-Receipt Number': '輸入電子收據號',
		'Search': '搜索',
		'E-Receipt No.': '電子收據號',
		'Student': '學員',
		'Charge/Refund': '收費/退費',
		'Amount': '金額',
		'Payment Methods': '付款方式',
		'Purchased Counts': '購買課次',
		'Operator': '經辦人',
		'Receipt No.': '收據號',
		'Added': '創建',
		'Payment': '收款',
		'Date': '收款日期',

	},
	monthlyFinance:{
		'Search by Date': '篩選日期',
		'Monthly Income':'本月收入',
		'Monthly Spending':'本月支出',
		'Net Income':'本月淨收入'
	},
	student: {
		'New Student: {name} Has Been Created': '新學員： {name} 已創建',
		"Student: {name}'s Info Has Been Updated": '學員： {name} 信息已更新',
		'Exited Class': '已退出班級',
		'You Do Not Have the Permission to Visit This Page, Please Contact the School Principle/Manager for More Information': '您所在的用戶組不具有此操作的權限，請聯絡該學校的校長或管理員授與您相應的權限',
		'Student {name} {remarks}': '學員 {name} {remarks}',
		'Student {name} {reason}': '學員 {name} {reason}',
		'Student Payment Failure': '學員繳費失敗',
		'Student: {name} Archived': '學員： {name} 已歸檔',
		'Student: {name} Unarchived': '學員： {name} 已恢復歸檔',
		'Multiple Student Archived': '多個學員已歸檔',
		'Student Info Update Failure': '學員狀態更新失敗',
		'Added': '加入',
		'Student: {name} Refunded {amount} {currency} Successful': '學員： {name} 退款 {amount} {currency} 成功',
		'Student: {name} Added Credit {amount} {currency} Successful': '學員： {name} 充值 {amount} {currency} 成功',
		'Student: {name} Charged {amount} {currency} Successful': '學員： {name} 收費 {amount} {currency} 成功',
		'Insufficient balance in your account, please add credit and try again': '當前您的錢包餘額不足，請充值後再使用',
		"Selected 'Reduce Lesson' is more than 'Purchased Lesson'": '選擇的“減少課期”大於“已購買課期',
		'When making a payment through your account, make sure you have sufficient balance. Please add credit to your account to continue': '當使用錢包餘額時，收款金額不能大於錢包餘額 為了正常交易，您可以先充值在使用錢包或使用其他交易方式',
		'Please select a class and enter the amount for refund': '請您首先選擇班級，並填入退款金額',
		'Please enter the appropriate refund amount': '請您填入合適退款金額',
		'Refund date cannot be empty': '退款日期不能為空',
		'Please select a class and enter the amount charged': '請您首先選擇班級，並填入收款金額',
		'Please enter the appropriate charged amount': '請您填入合適收款金額',
		'Charged date cannot be empty': '付款日期不能為空',
		'Proceed to archive student: {name} ？': '是否將學員： {name} 歸檔？',
		'Please exit all classes in order to archived student': '請您先在班級中歸檔，才可在學校中歸檔',
		'Proceed to unarchive student: {name} ？': '是否將學員： {name} 取消歸檔？',
		'Showing {amount} students Total of {amount2} students': '顯示 {amount} 人 全部 {amount2} 人',
		'Price ${fee}': '課價 ${fee}',
		'Exit student from class?': '確認將此學員退出班級？',
		'Exit Class': '退出班級',
		'Join Class': '加入班級',
		'Add Credit': '錢包充值',
		'Charged': '收費',
		'Add credit to your account and can be use to settle fees': '給此學員的校內錢包充值，並通用與任何校內費用的結算',
		'Collecting tuition fee and renewal': '直接收取學費、續費等',
		'Account Remaining: ': '錢包餘額兒： ',
		'Enter recipient email': '輸入收件人郵箱',
		'Paper Receipt Number': '輸入收據號',
		'Date': '充值日期',
		'Amount': '充值金額',
		'Purchased Lesson Until...': '購買課期至',
		'': '次',
		'Exit Lesson Until...' : '退課期至',
		'Exit Lesson Number': '退課次',
		'Choose one...': '請選擇...',
		'Purchased Lesson': '已購買課期',
		'Renew Lesson Until...': '續課期至',
		'Purchased Lesson Hour': '購買課時',
		'Hour': '小時',
		'Add remarks': '添加備註',
		'Edit Lesson Until...': '修改課期至',
		'Reduce Lesson Number': '減少課次',
		'Reduce Lesson Hour': '減少課時',
		'Join Current Classes': '加入當期班級',
		'Search Class Name': '搜索班級名稱...',
		'Currently Enrolled': '正在就讀',
		'You are over the student limit, please upgrade to premium version': '您目前的學員上限為50個學員, 添加更多學員請升級為高級版',
		'Create Class': '創建班級',
		'Create Student': '新增學員',
		'Multiple Students Has Been {action} To Class: {cname}': '多個學員被 {action} 到班级： {cname}',
		'View Now': '立即查看',
		'Failure: Students Are Already Enrolled In Class': '失敗： 學員已經加入該班级',
		'Current Student': '當期學員',
		'Not Enrolled Student': '未排班學員',
		'Enrolled Student': '在讀學員',
		'Pending Renewal Student': '待續費學員',
		'Archived Student': '往期學員',
		'Student': '學員',
		'Age': '年齡',
		'Class': '班級',
		'Class Status': '學費消耗',
		'Payment': '已缴學費',
		'Settings': '操作',
		'{i}': '{i}日',
		'Student List': '學生列表',
		"Archive": "歸檔",
		"Create Private Class": "創建私課",
		"Edit": "編輯",
		"Attendance": "查看簽到紀錄",
		'Remove "{sName}" From "{className}"?': '確認將此學生({sName})退出班級({className})嗎？',
		'Registration Guide': '前台報名',
		'Self-registration Setup': '前台報名設置',
		'Step One': '第一步',
		'Step Two': '第二步',
		'Step Three': '第三步',
		'Step Four': '第四步'

	},
	createstudent: {
		'Please enter a valid Email address': '請輸入正確的郵件地址',
		'Please enter a valid phone number': '請輸入正確的手機號碼',
		'Please upgrade to premium version': '請升級高級版',
		'{i}': '{i} 年',
		'January': '1月',
		'February': '2月',
		'March': '3月',
		'April': '4月',
		'May': '5月',
		'June': '6月',
		'July': '7月',
		'August': '8月',
		'September': '9月',
		'October': '10月',
		'November': '11月',
		'December': '12月',
		'First Name': '名稱',
		'Last Name': '姓氏',
		'Date of Birth': '生日',
		'Home Phone Number': '家庭電話',
		'Email': '郵件',
		'Nickname': '暱稱',
		'Source': '來源',
		'Parents Name': '家長名字',
		'Relationship': '親屬關係',
		'Address': '居住地址',
		'Register Date': '註冊日期',
		'Basic Information': '基本信息'
	},
	settings: {
		' Password': ' 密碼',
		'Reset Password': '重新設置密碼'
	},
	studentdetail:{
		'Paid Amount': '已繳學費',
		'Refund Amount': '退款學費',
		'Refund Lesson Date': '退款課期',
		'Refund Lesson Number': '退款課次',
		'Refund Lesson Hour': '退款課時',
		'Send To': '發送至',
		'{transaction_date1} - {transaction_date2} - {transaction_date3}': '{transaction_date1} 年 {transaction_date2} 月 {transaction_date3} 日',
		'Search Class': '所有',
		'Options': '充值方式',
		"Amount": '充值金額',
		'Student: {name}': '學員： {name}',
		'Account Balance {balance} CAD': '錢包現有金額: {balance} CAD',
		'Please enter amount': '請填入收款金額',
		'Amount needs to Bb greater than 0': '金額必須大於零',
		'Historical Class Record': '歷史班級',
		"Attendance Record": "簽到紀錄",
		'Tuition Record': '學費紀錄',
		'Edit Basic Information': '修改基本信息',
		'Account Balance: ': '錢包現有金額： ',
		'Paper Receipt No': '紙質收據號'
	}
}

export default locale



// WEBPACK FOOTER //
// ./src/locale/translations/CN_T.js